class locationsService {
    constructor($resource, CONFIG) {
        'ngInject';
        this.resource = {
            "countries": $resource(`${CONFIG.apiLocations.baseUrl}/country`),
            "hotels": $resource(`${CONFIG.apiLocations.baseUrl}/locations/:cityId/hotels`)
        };
    }

    getCountries() {
        return this.resource.countries.query().$promise;
    }

    getHotels(cityId) {
        return this.resource.hotels.query({cityId: cityId}).$promise;
    }

}

export default locationsService;


// WEBPACK FOOTER //
// ./client/app/api/locations/locations.service.js